<template>
  <div class="bg-theme-card rounded-2xl shadow-md overflow-hidden flex flex-col h-full border border-theme-border">
    <!-- Image skeleton with icon -->
    <div class="relative w-full aspect-[4/3] bg-theme-bg2 overflow-hidden">
      <div class="absolute inset-0 flex items-center justify-center">
        <i class="pi pi-image text-3xl sm:text-4xl text-theme-border opacity-50"></i>
      </div>
      <div class="skeleton-shimmer"></div>
    </div>

    <!-- Content skeleton -->
    <div class="px-2 pt-1.5 pb-2 sm:px-3 sm:pt-2.5 sm:pb-3 flex flex-col flex-grow gap-1.5 sm:gap-2">
      <!-- Owner row -->
      <div class="flex items-center gap-1.5">
        <div class="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-theme-bg2 relative overflow-hidden shrink-0">
          <div class="skeleton-shimmer"></div>
        </div>
        <div class="h-3 sm:h-3.5 bg-theme-bg2 rounded-full w-20 sm:w-24 relative overflow-hidden">
          <div class="skeleton-shimmer"></div>
        </div>
      </div>

      <!-- Name -->
      <div class="h-3.5 sm:h-4 bg-theme-bg2 rounded-full w-4/5 relative overflow-hidden">
        <div class="skeleton-shimmer"></div>
      </div>

      <!-- Rating + Distance row -->
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-1">
          <div class="flex gap-0.5">
            <div v-for="s in 5" :key="s" class="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-sm bg-theme-bg2 relative overflow-hidden">
              <div class="skeleton-shimmer"></div>
            </div>
          </div>
          <div class="h-3 bg-theme-bg2 rounded-full w-8 sm:w-10 relative overflow-hidden">
            <div class="skeleton-shimmer"></div>
          </div>
        </div>
        <div class="h-3 bg-theme-bg2 rounded-full w-12 sm:w-14 relative overflow-hidden">
          <div class="skeleton-shimmer"></div>
        </div>
      </div>

      <!-- Rate tier pills -->
      <div class="mt-auto">
        <div class="flex items-center gap-1 mb-1">
          <div v-for="t in 3" :key="t" class="h-5 bg-theme-bg2 rounded-full relative overflow-hidden"
            :class="t === 1 ? 'w-9 sm:w-11' : t === 2 ? 'w-10 sm:w-13' : 'w-11 sm:w-14'">
            <div class="skeleton-shimmer"></div>
          </div>
        </div>
        <!-- Price line -->
        <div class="flex items-baseline gap-1">
          <div class="h-4 sm:h-5 bg-theme-bg2 rounded-full w-16 sm:w-20 relative overflow-hidden">
            <div class="skeleton-shimmer"></div>
          </div>
          <div class="h-2.5 bg-theme-bg2 rounded-full w-6 sm:w-8 relative overflow-hidden">
            <div class="skeleton-shimmer"></div>
          </div>
        </div>
      </div>

      <!-- CTA button -->
      <div class="mt-0.5 sm:mt-1 h-7 sm:h-8 bg-theme-bg2 rounded-lg sm:rounded-xl w-full relative overflow-hidden">
        <div class="skeleton-shimmer"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.skeleton-shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.08) 20%,
    rgba(255, 255, 255, 0.18) 50%,
    rgba(255, 255, 255, 0.08) 80%,
    transparent 100%
  );
  animation: shimmer 1.8s ease-in-out infinite;
}

@media (prefers-color-scheme: light) {
  .skeleton-shimmer {
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(0, 0, 0, 0.03) 20%,
      rgba(0, 0, 0, 0.06) 50%,
      rgba(0, 0, 0, 0.03) 80%,
      transparent 100%
    );
  }
}

:root:not(.dark) .skeleton-shimmer {
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(0, 0, 0, 0.03) 20%,
    rgba(0, 0, 0, 0.06) 50%,
    rgba(0, 0, 0, 0.03) 80%,
    transparent 100%
  );
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
</style>
